@if (!isLoadingStatus) {
	<div class="status-container">
		@if (statusIntarface.id === undefined) {
			<div>
				<msp-table-rmk
					[enableSorting]="true"
					[sort]="sort"
					(getSort)="sort = $event"
					[headers]="searchHeader"
					[data]="statusListTable()"
					[onLineClick]="onLineClick"></msp-table-rmk>

				<div class="button-container">
					<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo }}</div>
				</div>
			</div>
		}

		@if (statusIntarface.id !== undefined) {
			<div class="header-wrap">
				<span class="tab selected">{{ labels.lbl_status }}</span>
			</div>
			<div class="body-wrap">
				<div class="search-container">
					<div class="form-container">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_asset_tipo_ci }}</span>
							<select id="type" name="type" [(ngModel)]="statusIntarface.ci_type">
								<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
								@for (option of ciTypeList; track $index) {
									<option [value]="option.id">{{ option.label }}</option>
								}
							</select>
						</div>

						<div class="dotted-input-container">
							<span
								>{{ labels.lbl_status_relacionado }}
								<fa-icon [icon]="icons.faInfoCircle" [title]="labels.lbl_vincular_status_estoque"></fa-icon
							></span>
							<select id="status_related" name="status_related" [(ngModel)]="statusIntarface.status_related">
								<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
								@for (status of statusPatternList; track $index) {
									<option [value]="status.status_related">{{ status.status_related }}</option>
								}
							</select>
						</div>

						<div class="dotted-input-container">
							<span>{{ labels.lbl_status_ci }}*</span>
							<select id="status_active" name="status_active" [(ngModel)]="statusIntarface.status_active">
								<option [value]="''" selected disabled hidden>{{ labels.lbl_geral_selecione }}</option>
								<option [value]="0">{{ labels.lbl_geral_desativado }}</option>
								<option [value]="1">{{ labels.lbl_geral_ativo }}</option>
							</select>
						</div>

						<div class="dotted-input-container">
							<span>{{ labels.lbl_status }}*</span>
							<input id="status" name="status" type="text" [(ngModel)]="statusIntarface.status" />
						</div>

						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_ativo }}*</span>
							<select id="active" name="active" [(ngModel)]="statusIntarface.active">
								<option [value]="''" selected disabled hidden>{{ labels.lbl_geral_selecione }}</option>
								<option [value]="0">{{ labels.lbl_geral_desativado }}</option>
								<option [value]="1">{{ labels.lbl_geral_ativo }}</option>
							</select>
						</div>
					</div>

					<div class="button-container">
						<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
						<msp-button [loading]="isSavingForm" (click)="validateForm()">{{ labels.lbl_geral_salvar }}</msp-button>
					</div>
				</div>
			</div>
		}
	</div>
}

@if (isLoadingStatus) {
	<cpi-dot-bounce-loading-effect class="mt-2 ml-2" [color]="'var(--primary-color-1)'"> </cpi-dot-bounce-loading-effect>
}
